import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Clearfix } from 'react-bootstrap';

import IntlDate from 'components/layout/IntlDate';

import RichEditorContent from 'components/RichEditorContent';
import CopyToClipboard from 'components/CopyToClipboard';

import AbstractTimelineEvent from './AbstractTimelineEvent';

class TimelineFilledQuestionnaireSaved extends AbstractTimelineEvent {
  render() {
    const {
      intl: { messages },
      appIntl,
      event,
    } = this.props;

    const filledQuestionnaireToken = this.getParam('filledQuestionnaireToken');
    const questionnaireLink = window.location.origin + appIntl.urlPrefix + 'questionnaires/' + filledQuestionnaireToken;

    return (
      <div className="card-block">
        <RichEditorContent content={'<div>' + event.getText() + '</div>'} />

        <div className="p-t-10">
          <p>{messages.infos}</p>
          <dl>
            {!!this.getDynParam('filledOut') && (
              <React.Fragment>
                <dt>{messages.questionnaire_filled_out}</dt>
                <dd className="m-b-5">
                  <IntlDate date={this.getDynParam('filledOutOn')} />
                </dd>
              </React.Fragment>
            )}
            <dt>{messages.link}</dt>
            <dd>
              <Clearfix>
                <div className="relative pull-left p-r-25 overflow-ellipsis" style={{ maxWidth: '100%' }}>
                  <a href={questionnaireLink} target="_blank">
                    {questionnaireLink}
                  </a>
                  <div className="top-right">
                    <CopyToClipboard text={questionnaireLink} />
                  </div>
                </div>
              </Clearfix>
            </dd>
          </dl>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default injectIntl(connect(mapStateToProps)(TimelineFilledQuestionnaireSaved));
